import React, { useState } from "react";


export default function Main() {

const [count, setCount] = useState(0)
const [isAnimating, setIsAnimating] = useState(false);

function sheepAnimate() {
    setIsAnimating(true);
  }

function add() {
    setCount(count + 1);
}

function stopSheepAnimate() {
    setIsAnimating(false);
}

function reset() {
    setCount(0)
    setIsAnimating(false);
}

    return(
        <main>
            <div className="main--container">
                <h1 className="main--title">Ready to fall asleep counting sheep?</h1>
                    <div className="main--sheep-jump-area">
                    <h1 className="counter-display">{count}</h1>
                    <img className={`main--sheep ${isAnimating ? "sheep-animate" : ""}`} 
                    src={require (`./images/sheep.png`)}></img>
                    <img className="main--fence" src={require (`./images/fence.png`)}></img>
                    </div>
                <div className="main--buttons-container">
                    <button className="main--buttons" onClick={sheepAnimate}>Start</button>
                    <button className="main--buttons" onClick={add}>Count</button>
                    <button className="main--buttons" onClick={stopSheepAnimate}>Pause</button>
                    <button className="main--buttons" onClick={reset}>Reset</button>
                </div>
            </div>
        </main>
    )
}